// Format a localStorage timestamp as a relative-time string. Both apps shipped
// near-identical copies; consolidated here. Takes pre-translated templates so
// the helper has no i18n dependency.
export interface RelativeTimeStrings {
  readonly justNow: string;
  // Receive the unit count so the consumer can apply its own plural rules.
  readonly minutesAgo: (count: number) => string;
  readonly hoursAgo: (count: number) => string;
  readonly daysAgo: (count: number) => string;
}

export function relativeTime(
  ts: number,
  strings: RelativeTimeStrings,
  now: number = Date.now(),
): string {
  const diffMs = now - ts;
  const diffMin = Math.floor(diffMs / 60_000);
  if (diffMin < 1) return strings.justNow;
  if (diffMin < 60) return strings.minutesAgo(diffMin);
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return strings.hoursAgo(diffHr);
  const diffDay = Math.floor(diffHr / 24);
  return strings.daysAgo(diffDay);
}
